export class NumberHelper {
  public static pad(number: number, width: number, padding: string = '0') {
    const res = number.toString();

    return res.length >= width ? number : new Array(width - res.length + 1).join(padding) + res;
  }

  public static parsePercentage(value?: number): number {
    return parseFloat(((value || 0) / 100).toFixed(2));
  }
}
